import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { useCreateXenditIntegration } from 'modules/profile/payment-gateways/integrations/xendit/hooks';
import { XenditCreateIntegrationInterface, XenditIntegrationErrorsInterface } from 'modules/profile/payment-gateways/integrations/xendit/types';
import { getXenditHelpPageLink } from 'modules/profile/payment-gateways/integrations/xendit/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: XenditCreateIntegrationInterface = {
  organizationName: '',
  webhookSecret: '',
  secretAccessToken: '',
  publicAccessToken: ''
};
const defaultErrors: XenditIntegrationErrorsInterface = {
  organizationName: '',
  webhookSecret: '',
  secretAccessToken: '',
  publicAccessToken: ''
};
const XenditCreateModal = () => {
  const $ = _c(49);
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    createXenditIntegration
  } = useCreateXenditIntegration();
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t0;
  if ($[0] !== createXenditIntegration || $[1] !== mutatePaymentIntegrations) {
    t0 = async data => {
      await fetchWithErrors(async () => {
        await createXenditIntegration(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = createXenditIntegration;
    $[1] = mutatePaymentIntegrations;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onCreate = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.settings.payment_gateways.connect");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <PrimaryButton onClick={t1} className="font-bold">{t2}</PrimaryButton>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t || $[9] !== tUi) {
    t4 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.XenditID, tUi)
    });
    $[8] = t;
    $[9] = tUi;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("dashboard.settings.payment-gateways.xendit_integration");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpened(false);
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== errors || $[15] !== t) {
    t7 = {
      field: "organizationName",
      onRender: (value, onChange) => <FormInput key="xendit-organization-name-create" label={t("dashboard.settings.payment-gateways.organization_name")} value={value} onChange={e_0 => onChange(e_0.target.value)} required={true} error={errors.organizationName} />
    };
    $[14] = errors;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== errors || $[18] !== t) {
    t8 = {
      field: "webhookSecret",
      onRender: (value_0, onChange_0) => <FormInput key="xendit-webhook-secret-create" label={t("dashboard.settings.payment-gateways.webhook_secret")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} required={true} error={errors.webhookSecret} />
    };
    $[17] = errors;
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== errors || $[21] !== t) {
    t9 = {
      field: "secretAccessToken",
      onRender: (value_1, onChange_1) => <FormInput key="xendit-secret-access-token-create" label={t("dashboard.settings.payment-gateways.secret_access_token")} value={value_1} onChange={e_2 => onChange_1(e_2.target.value)} required={true} error={errors.secretAccessToken} />
    };
    $[20] = errors;
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== errors || $[24] !== t) {
    t10 = {
      field: "publicAccessToken",
      onRender: (value_2, onChange_2) => <FormInput key="xendit-public-access-token-create" label={t("dashboard.settings.payment-gateways.public_access_token")} value={value_2} onChange={e_3 => onChange_2(e_3.target.value)} required={true} error={errors.publicAccessToken} />
    };
    $[23] = errors;
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t11 = [t7, t8, t9, t10];
    $[26] = t10;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const t12 = user?.dashboardLocale;
  let t13;
  if ($[31] !== t12) {
    t13 = getXenditHelpPageLink(t12);
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== tUi) {
    t14 = getPaymentProcessorTitle(PaymentProcessorEnum.XenditPH, tUi);
    $[33] = tUi;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t13 || $[36] !== t14) {
    t15 = <HelpCenterLink link={t13} integration={t14} />;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = ["organizationName", "webhookSecret", "secretAccessToken", "publicAccessToken"];
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== onCreate || $[40] !== opened || $[41] !== t11 || $[42] !== t15 || $[43] !== t4 || $[44] !== t5) {
    t17 = <CreateModal fullCaption={t4} caption={t5} opened={opened} onClose={t6} defaultValues={defaultValues} needToast={false} creatable={t11} additionalInfo={t15} onCreate={onCreate} requiredFields={t16} />;
    $[39] = onCreate;
    $[40] = opened;
    $[41] = t11;
    $[42] = t15;
    $[43] = t4;
    $[44] = t5;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t17 || $[47] !== t3) {
    t18 = <>{t3}{t17}</>;
    $[46] = t17;
    $[47] = t3;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
};
export default XenditCreateModal;